import React from 'react';
import Hero from '../components/Hero';
import NavHome from '../components/NavHome';
import '../css/home.css';
const Home = () => {
  return (
    <>
      <NavHome />
      <Hero />
    </>
  );
};
export default Home;
